import { selector } from 'recoil';
import { PartyRelationTypeId } from '@zurich/api/party';
import { allValid, alwaysValid, validateSchema } from '@zurich/common/recoil';
import { partyRelationPartySchema, partyRelationSharesSchema, partyRelationTypeSchema, partyRelationVoucherSchema, } from '../../forms';
import { localPartyRelationPartyASelector, localPartyRelationPartyBSelector, localPartyRelationSharesSelector, localPartyRelationTypeSelector, localPartyRelationVoucherSelector, } from '../selectors/localPartyRelation';
export const localPartyRelationTypeValidationSelector = selector({
    key: 'validation/local/partyRelation/relationType',
    get: ({ get }) => {
        const relationType = get(localPartyRelationTypeSelector);
        return validateSchema(partyRelationTypeSchema, relationType);
    },
});
export const localPartyRelationSharesValidationSelector = selector({
    key: 'validation/local/partyRelation/shares',
    get: ({ get }) => {
        const relationType = get(localPartyRelationTypeSelector);
        const shares = get(localPartyRelationSharesSelector);
        // shares are required for 'Wirtschaftlicher Eigentümer'
        if (relationType?.id?.toString() === '14' ||
            relationType?.id?.toString() === '15') {
            return validateSchema(partyRelationSharesSchema, shares);
        }
        return alwaysValid(null);
    },
});
export const localPartyRelationPartyAValidationSelector = selector({
    key: 'validation/local/partyRelation/partyA',
    get: ({ get }) => {
        const partyA = get(localPartyRelationPartyASelector);
        return validateSchema(partyRelationPartySchema, partyA);
    },
});
export const localPartyRelationPartyBValidationSelector = selector({
    key: 'validation/local/partyRelation/partyB',
    get: ({ get }) => {
        const partyB = get(localPartyRelationPartyBSelector);
        return validateSchema(partyRelationPartySchema, partyB);
    },
});
export const localPartyRelationCreateFormValidationSelector = selector({
    key: 'validation/local/partyRelation/createForm',
    get: ({ get }) => allValid({
        partyRelationType: get(localPartyRelationTypeValidationSelector),
        partyRelationShares: get(localPartyRelationSharesValidationSelector),
        partyRelationPartyA: get(localPartyRelationPartyAValidationSelector),
        partyRelationPartyB: get(localPartyRelationPartyBValidationSelector),
        partyRelationVoucher: get(localPartyRelationVoucherValidationSelector),
    }),
});
export const localPartyRelationUpdateFormValidationSelector = selector({
    key: 'validation/local/partyRelation/updateForm',
    get: ({ get }) => allValid({
        partyRelationType: get(localPartyRelationTypeValidationSelector),
    }),
});
export const localPartyRelationVoucherValidationSelector = selector({
    key: 'validation/local/partyRelation/voucher',
    get: ({ get }) => {
        const relationType = get(localPartyRelationTypeSelector);
        if (relationType?.id === PartyRelationTypeId.RECRUITER) {
            return validateSchema(partyRelationVoucherSchema, get(localPartyRelationVoucherSelector));
        }
        return alwaysValid(null);
    },
});
